// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header-container {
  background-color: white;
  padding: 10px;
  box-shadow: 0px 0px 4px 3px lightgrey;
}

.main-header-tab {
  flex-basis: 100%;
  cursor: pointer;
}

.stat-item {
  margin-bottom: 3px;
  font-size: 0.8rem;
  font-weight: 600;
}

.snapshot-card-list-container {
  display: flex;
  justify-content: center;
}
.snapshot-card-list-container .snapshop-container-area {
  border: 1px solid lightgray;
  border-radius: 20px;
  width: 50%;
}
.snapshot-card-list-container .snapshot-card-list {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-group-label {
  border-bottom: 1px solid lightgray;
  width: 60%;
  font-size: 0.8rem;
  margin-bottom: 3px;
}
.snapshot-card-list-container .snapshot-card-list .t1 {
  margin-right: 10px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card {
  display: block;
  text-align: center;
  margin: 0px 15px 10px 0px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-top {
  font-size: 0.8rem;
  font-weight: 500;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.gray {
  border-bottom: 2px solid gray;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.silver {
  border-bottom: 2px solid #C3CDE6;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-highlight.gold {
  border-bottom: 2px solid gold;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-center {
  display: none;
  font-size: 1.5rem;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-bottom {
  font-size: 14px;
}
.snapshot-card-list-container .snapshot-card-list .snapshot-card .snapshot-card-next {
  font-size: 12px;
  color: deepskyblue;
}`, "",{"version":3,"sources":["webpack://./src/app/components/andrena-main-header/andrena-main-header.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EAGA,aAAA;EACA,qCAAA;AADJ;;AAIA;EACI,gBAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AADJ;;AAIA;EAGI,aAAA;EACA,uBAAA;AAHJ;AAaI;EACI,2BAAA;EACA,mBAAA;EACA,UAAA;AAXR;AAcI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAZR;AAgBQ;EACI,kCAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AAdZ;AAiBQ;EACI,kBAAA;AAfZ;AAkBQ;EAII,cAAA;EACA,kBAAA;EAEA,yBAAA;AApBZ;AAyBY;EACI,iBAAA;EACA,gBAAA;AAvBhB;AA2BgB;EACI,6BAAA;AAzBpB;AA4BgB;EACI,gCAAA;AA1BpB;AA6BgB;EACI,6BAAA;AA3BpB;AA+BY;EACI,aAAA;EACA,iBAAA;AA7BhB;AAiCY;EACI,eAAA;AA/BhB;AAkCY;EACI,eAAA;EACA,kBAAA;AAhChB","sourcesContent":[".main-header-container  {\n    background-color: white;\n    //height: 135px;\n    //background-color: rgb(250, 250, 250);\n    padding: 10px;\n    box-shadow: 0px 0px 4px 3px lightgrey;\n}\n\n.main-header-tab {\n    flex-basis: 100%;\n    cursor: pointer;\n}\n\n.stat-item {\n    margin-bottom: 3px;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.snapshot-card-list-container {\n    //border-bottom: 1px solid lightgrey;\n    // padding: 22px;\n    display: flex;\n    justify-content: center;\n\n    h4 {\n        \n    }\n\n    .snapshot-card-list-header {\n\n    }\n\n    .snapshop-container-area {\n        border: 1px solid lightgray;\n        border-radius: 20px;\n        width: 50%;\n    }\n\n    .snapshot-card-list {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        //margin: 10px 0px;\n        \n\n        .snapshot-group-label {\n            border-bottom: 1px solid lightgray;\n            width: 60%;\n            font-size: 0.8rem;\n            margin-bottom: 3px;\n        }\n\n        .t1 {\n            margin-right: 10px;\n        }\n\n        .snapshot-card {\n            //-webkit-box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            //-moz-box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            //box-shadow:0 0 10px rgba(0, 0, 0, 0.5);\n            display: block;\n            text-align: center;\n            //padding: 15px 30px;\n            margin: 0px 15px 10px 0px;\n            //border-radius: 2px 2px 2px 2px;\n            //min-width: 180px;\n            //margin: 0px 20px;\n            \n            .snapshot-card-top {\n                font-size: 0.8rem;\n                font-weight: 500;\n            }\n\n            .snapshot-highlight {\n                &.gray {\n                    border-bottom: 2px solid gray;\n                }\n\n                &.silver {\n                    border-bottom: 2px solid #C3CDE6;\n                }\n\n                &.gold {\n                    border-bottom: 2px solid gold;\n                }\n            }\n\n            .snapshot-card-center {\n                display: none;\n                font-size: 1.5rem;\n                // font-size: 1.5rem;\n            }\n\n            .snapshot-card-bottom {\n                font-size: 14px\n            }\n\n            .snapshot-card-next {\n                font-size: 12px;\n                color: deepskyblue;\n            }\n\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
